module.exports = new __parcel__URL__("jpd-board-blank.bfb49c94.svg").toString();